import { render, staticRenderFns } from "./main-menu.vue?vue&type=template&id=47f43d47&"
import script from "./main-menu.vue?vue&type=script&lang=js&"
export * from "./main-menu.vue?vue&type=script&lang=js&"
import style0 from "./main-menu.vue?vue&type=style&index=0&id=47f43d47&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports